import {PageHeader} from "../components/PageHeader";
import {LegalDocument} from "../components/LegalDocument";
import {format, legalPages} from "../i18n";
import {legal} from "../legal";

// The statement is src/i18n/en/legal/accessibility.md. Keep its known limitations honest, and update
// legal.accessibilityReviewed after each review.
export function AccessibilityPage() {
    return (
        <div className="legal-text">
            <PageHeader title={legalPages.accessibility.title} description={legalPages.accessibility.description}/>
            <p className="text-body-secondary">{format(legalPages.lastReviewed, { date: legal.accessibilityReviewed })}</p>
            <LegalDocument markdown={legalPages.accessibility.document} values={legal}/>
        </div>
    );
}
